import * as React from 'react';
import checkIcon from '@/assets/images/svg/purple_check_icon.svg';

const FREE_BENEFITS = [
  'Searches across social media, news, and public content',
  'Analyzes and extracts relevant personality traits',
  'Improves response accuracy and authenticity',
  'Takes approximately 2-5 minutes to complete',
];

const PREMIUM_BENEFITS = [
  'Deep scraping across social media, interviews, and articles',
  'Advanced personality analysis with nuance detection',
  'Substantially improves response accuracy and authenticity',
  'Processes more sources for a richer, more detailed persona',
  'Takes approximately 5-10 minutes to complete',
];

interface BenefitListProps {
  variant?: 'free' | 'premium';
}

/** Renders benefit list for free or premium internet data collection. */
export const BenefitList: React.FC<BenefitListProps> = ({ variant = 'free' }) => {
  const benefits = variant === 'premium' ? PREMIUM_BENEFITS : FREE_BENEFITS;

  return (
    <ul className='flex flex-col gap-3'>
      {benefits.map((item, index) => (
        <li key={index} className='flex items-start gap-3'>
          <img src={checkIcon} alt='' className='mt-1 size-5 shrink-0' />
          <span className='font-sans text-16 font-normal leading-24 text-gray-600'>{item}</span>
        </li>
      ))}
    </ul>
  );
};
